import type { TaxGroup } from '@/types/schemas/nhom-thue.type';
import type { DataTableColumn } from '@/components/custom/erp';

export const getDataTableColumns = (): DataTableColumn<TaxGroup>[] => [
  {
    field: 'ma_nhom',
    headerName: 'Mã nhóm',
    width: 150,
    renderCell: params => <div className='cursor-pointer text-main hover:underline'>{String(params.value ?? '')}</div>
  },
  {
    field: 'ten_phan_nhom',
    headerName: 'Tên nhóm',
    width: 200
  }
];
